import { render, staticRenderFns } from "./EpayTrade.vue?vue&type=template&id=0cbdd028&scoped=true"
import script from "./EpayTrade.vue?vue&type=script&lang=js"
export * from "./EpayTrade.vue?vue&type=script&lang=js"
import style0 from "./EpayTrade.vue?vue&type=style&index=0&id=0cbdd028&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbdd028",
  null
  
)

export default component.exports